import { Injectable } from '@angular/core';

@Injectable()
export class HelpersService {
  ///
  /// addCommas
  ///
  /// Insert commas into a number for display
  ///
  //eslint-disable-next-line
  addCommas(nStr: string): any {
    nStr += '';
    const x = nStr.split('.');
    let x1 = x[0];
    const x2 = x.length > 1 ? '.' + x[1] : '';
    const rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, '$1' + ',' + '$2');
    }
    return x1 + x2;
  }

  //
  // formatTOS
  //
  // ensure TOS value is padded to the left with zeros and
  // if it was entered as a decimal or hex value, convert it to binary
  //eslint-disable-next-line
  formatTOS(tosValue: string): any {
    let formattedValue = tosValue;

    if ((typeof tosValue === 'number' || typeof tosValue === 'string') && tosValue.length < 8) {
      const num = parseInt(tosValue);
      if (!isNaN(num)) {
        const numValue = '00000000' + num.toString(2);
        formattedValue = numValue.slice(numValue.length - 8);
      }
    }
    return formattedValue;
  }

  //
  // turn an diffvalue integer value back to a displayable string
  //eslint-disable-next-line
  formatDiffValue(diffvalue: any): any {
    const dscpString = {
      0: 'Best Effort (0)(0)',
      32: 'Class Selector 1 (8)(32)',
      40: 'AF 11 (10)(40)',
      48: 'AF 12 (12)(48)',
      56: 'AF 13 (14)(56)',
      64: 'Class Selector 2 (16)(64)',
      72: 'AF 21 (18)(72)',
      80: 'AF 22 (20)(80)',
      88: 'AF 23 (22)(88)',
      96: 'Class Selector 3 (24)(96)',
      104: 'AF 31 (26)(104)',
      112: 'AF 32 (28)(112)',
      120: 'AF 33 (30)(120)',
      128: 'Class Selector 4 (32)(128)',
      136: 'AF 41 (34)(136)',
      144: 'AF 42 (36)(144)',
      152: 'AF 43 (38)(152)',
      160: 'Class Selector 5 (40)(160)',
      168: 'AF 51 (42)(168)',
      176: 'AF 52 (44)(176)',
      184: 'Exp. Forwarding  (46)(184)',
      192: 'Class Selector 6 (48)(192)',
      224: 'Class Selector 7 (56)(224)'
    };

    if (dscpString[diffvalue]) {
      return dscpString[diffvalue];
    }
    return diffvalue;
  }

  //
  // convertSecondsToHMS
  //
  // convert integer value in seconds to HH:MM:SS format
  //

  convertSecondsToHMS(value: string): string {
    let rtnValue = '';
    try {
      const nSecs = parseInt(value);
      if (!isNaN(nSecs)) {
        const hourValue = Math.floor(nSecs / (60 * 60));
        let hours = hourValue.toString();
        if (hourValue < 10) {
          hours = '0' + hours;
        }

        const divisor_for_minutes = nSecs % (60 * 60);
        const minuteValue = Math.floor(divisor_for_minutes / 60);
        let minutes = minuteValue.toString();
        if (minuteValue < 10) {
          minutes = '0' + minutes;
        }

        const divisor_for_seconds = divisor_for_minutes % 60;
        const secondsValue = Math.ceil(divisor_for_seconds);
        let seconds = secondsValue.toString();
        if (secondsValue < 10) {
          seconds = '0' + seconds;
        }

        rtnValue = hours + ':' + minutes + ':' + seconds;
      }
      return rtnValue;
    } catch (err) {
      return value;
    }
  }

  //
  // createPublicAccessURL
  //
  // build the URL based on public access server info and sha
  //eslint-disable-next-line
  createPublicAccessURL(serverConfig: any, sha: string): any {
    let url = null;
    if (serverConfig && typeof sha === 'string') {
      if (
        serverConfig['vibe-public-access'] &&
        serverConfig['vibe-public-access'].protocol &&
        serverConfig['vibe-public-access'].hostname &&
        serverConfig['vibe-public-access'].port &&
        serverConfig['vibe-public-access'].path &&
        typeof serverConfig['vibe-public-access'].path == 'string'
      ) {
        const myhostname = serverConfig['vibe-public-access'].hostname;
        if (myhostname !== '0.0.0.0' && myhostname !== '127.0.0.1' && myhostname !== 'localhost') {
          url = serverConfig['vibe-public-access'].protocol + '://' + myhostname;
          if (serverConfig['vibe-public-access'].port != 80) {
            url += ':' + serverConfig['vibe-public-access'].port;
          }
          if (serverConfig['vibe-public-access'].path.indexOf('/') !== 0) {
            url += '/';
          }
          url += serverConfig['vibe-public-access'].path + sha;
        }
      }
    }
    return url;
  }

  //eslint-disable-next-line
  generateSecondaryTestURL(
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    serverConfig: any,
    shaID: string,
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    selectedOriginator: any
  ): any {
    let port = null;
    let proxyIP = null;
    let url = null;
    if (
      selectedOriginator &&
      selectedOriginator.deviceData &&
      selectedOriginator.deviceData.capabilities
    ) {
      if (
        selectedOriginator.deviceData.capabilities.proxy &&
        selectedOriginator.deviceData.capabilities.proxy['local-port']
      ) {
        // if there is no proxy will not have the secondary URL
        port = selectedOriginator.deviceData.capabilities['proxy']['local-port'];
      }
      if (
        selectedOriginator.deviceData.capabilities.truespeed &&
        selectedOriginator.deviceData.capabilities['truespeed']['public-access-ip']
      ) {
        proxyIP = selectedOriginator.deviceData.capabilities['truespeed']['public-access-ip'];
      }
      if (port && proxyIP) {
        if (
          serverConfig &&
          serverConfig['vibe-public-access'].protocol &&
          serverConfig['vibe-public-access'].path
        ) {
          url = serverConfig['vibe-public-access'].protocol + '://';
          url += proxyIP + ':' + port;
          url += serverConfig['vibe-public-access'].path + shaID;
          //this.clientToAgentInfo.secondaryTestURL = url;
        }
      }
    }
    return url;
  }

  //eslint-disable-next-line
  generateSecondaryTestUDPURL(
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    serverConfig: any,
    shaID: string,
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    selectedOriginator: any
  ): any {
    let port = null;
    let proxyIP = null;
    let url = null;
    if (
      selectedOriginator &&
      selectedOriginator.deviceData &&
      selectedOriginator.deviceData.capabilities
    ) {
      if (
        selectedOriginator.deviceData.capabilities.proxy &&
        selectedOriginator.deviceData.capabilities.proxy['local-port']
      ) {
        // if there is no proxy will not have the secondary URL
        port = selectedOriginator.deviceData.capabilities['proxy']['local-port'];
      }
      if (
        selectedOriginator.deviceData.capabilities.truespeed &&
        selectedOriginator.deviceData.capabilities['udp']['public-access-ip']
      ) {
        proxyIP = selectedOriginator.deviceData.capabilities['udp']['public-access-ip'];
      }
      if (port && proxyIP) {
        if (
          serverConfig &&
          serverConfig['vibe-public-access'].protocol &&
          serverConfig['vibe-public-access'].path
        ) {
          url = serverConfig['vibe-public-access'].protocol + '://';
          url += proxyIP + ':' + port;
          url += serverConfig['vibe-public-access'].path + shaID;
          //this.clientToAgentInfo.secondaryTestURL = url;
        }
      }
    }
    return url;
  }

  ///
  /// give two strings with numbers and dots that represent a software version
  /// Example: 2.3.1
  /// thisVersion - the version number to equal or be higher than
  /// versionToCompare - the version that needs to be compared
  ///
  /// return true if the versionToCompare is higher than thisVersion, otherwise false
  ///
  isVersionGreaterThanEqualTo(thisVersion: string, versionToCompare: string): boolean {
    if (
      thisVersion &&
      typeof thisVersion === 'string' &&
      versionToCompare &&
      typeof versionToCompare === 'string'
    ) {
      const thisVersionSplit = thisVersion.split('.');
      if (thisVersionSplit.length < 1) {
        return false;
      }

      const versionToCompareSplit = versionToCompare.split('.');
      if (versionToCompareSplit.length < 1) {
        return false;
      }

      const majorGood = parseInt(thisVersionSplit[0], 10);
      const minorGood = thisVersionSplit.length > 1 ? parseInt(thisVersionSplit[1], 10) : 0;
      const revisionGood = thisVersionSplit.length > 2 ? parseInt(thisVersionSplit[2], 10) : 0;

      const majorCmp = parseInt(versionToCompareSplit[0], 10);
      const minorCmp =
        versionToCompareSplit.length > 1 ? parseInt(versionToCompareSplit[1], 10) : 0;
      const revisionCmp =
        versionToCompareSplit.length > 2 ? parseInt(versionToCompareSplit[2], 10) : 0;

      if (
        majorCmp > majorGood ||
        (majorCmp === majorGood && minorCmp > minorGood) ||
        (majorCmp === majorGood && minorCmp === minorGood && revisionCmp >= revisionGood)
      ) {
        return true;
      }
    }
    return false;
  }

  ///
  /// convert an ISO like UTC date string that the probe/agent creates into a Unix timestamp
  ///
  /// dateString looks like: "2018-10-03T20:38:49+00.00"
  ///
  //eslint-disable-next-line
  getUTCTimeFromISODateString(dateString: string): any {
    if (dateString && typeof dateString === 'string') {
      // carve it up
      let dateSplit = dateString.split('T');
      const date = dateSplit[0];
      const time = dateSplit[1].split('+')[0];

      dateSplit = date.split('-');
      const timeSplit = time.split(':');

      return Date.UTC(
        parseInt(dateSplit[0]),
        parseInt(dateSplit[1]) - 1,
        parseInt(dateSplit[2]),
        parseInt(timeSplit[0]),
        parseInt(timeSplit[1]),
        parseInt(timeSplit[2])
      );
    }
    return 0;
  }

  ///
  /// give me a model name and I will return boolean true if it is a known MTS model
  ///
  isModelMTS(model: string): boolean {
    const mtsModelList = [
      'TB/MTS-5800-100G',
      'TB/MTS-5800v2',
      'MTS-5882',
      'SC4800',
      'SC4800P',
      'TB-5800v2',
      'MTS-5800v2',
      'TB-5882',
      'MAP-2100',
      'TB-5800-100G',
      'MTS-5800-100G'
    ];

    return mtsModelList.indexOf(model) > -1;
  }
  //eslint-disable-next-line
  formatDate(input: any): any {
    const dateString =
      input.substring(0, 4) +
      '-' +
      input.substring(4, 6) +
      '-' +
      input.substring(6, 8) +
      ' ' +
      input.substring(8, 10) +
      ':' +
      input.substring(10, 12);
    return dateString;
  }

  //eslint-disable-next-line
  getResponseErrorMsg(responseObj) {
    let errorMsg = null;

    if (responseObj == null) {
      errorMsg = 'Response is empty';
    } else if (responseObj.status && responseObj.status == 'error') {
      if (responseObj.data && responseObj.data.code && responseObj.data.message) {
        if (responseObj.op) {
          errorMsg =
            'Response error; Operation[' +
            responseObj.op +
            ']  Message[' +
            responseObj.data.message +
            '] Code[' +
            responseObj.data.code +
            ']';
        } else {
          errorMsg =
            'Response error; Message[' +
            responseObj.data.message +
            '] Code[' +
            responseObj.data.code +
            ']';
        }
      } else {
        errorMsg = 'Response contained an unspecified error';
      }
    }
    return errorMsg;
  }
  //eslint-disable-next-line
  getCurrentTimeDate() {
    const currentTime = new Date();
    const timeDate =
      currentTime.getHours() +
      ':' +
      ('0' + currentTime.getMinutes()).slice(-2) +
      ':' +
      ('0' + currentTime.getSeconds()).slice(-2) +
      ' ' +
      (currentTime.getMonth() + 1) +
      '/' +
      currentTime.getDate() +
      '/' +
      currentTime.getFullYear();
    return timeDate;
  }

  //eslint-disable-next-line
  getReportDateTimeString(isoDateString: string) {
    const localeOptions: any = { dateStyle: 'medium', timeStyle: 'short', hour12: false };
    return new Date(isoDateString).toLocaleString('en', localeOptions);
  }

  //eslint-disable-next-line
  replaceAll = function (stringParam, origVal, newVal) {
    if (
      typeof stringParam === 'string' &&
      typeof origVal === 'string' &&
      typeof newVal === 'string'
    ) {
      return stringParam.split(origVal).join(newVal);
    } else {
      return stringParam;
    }
  };
}
